const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUltimaSvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402.9328 60.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "logoMark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.1723,59.6777a26.7659,26.7659,0,0,1-22.6974-12.58l-2.8938-4.63a26.7657,26.7657,0,0,0-22.6971-12.58H107.9889a26.7656,26.7656,0,0,1,22.6972,12.58l2.894,4.63c.122.1957.2569.38.3836.5723a26.8563,26.8563,0,0,1-14.9163,10.94A26.7558,26.7558,0,0,1,103.79,47.0978L93.0036,29.84,103.698,12.7288A26.8627,26.8627,0,0,1,119.04,1.1631a26.8635,26.8635,0,0,1,15.3417,11.5657l1.4151,2.2639h14.8951l-1.4151-2.2639A26.8742,26.8742,0,0,0,126.4873.0976H111.5922A26.8739,26.8739,0,0,0,88.8029,12.7288L85.556,17.9235l-3.2787-5.246A26.7658,26.7658,0,0,0,59.58.0976H44.685a26.7663,26.7663,0,0,1,22.6975,12.58l21.5125,34.42c.1221.1957.2567.38.3837.5723A26.8563,26.8563,0,0,1,74.3624,58.61,26.7555,26.7555,0,0,1,59.1049,47.0978l-21.5126-34.42A26.7661,26.7661,0,0,0,14.8951.0976H0a26.7654,26.7654,0,0,1,22.6972,12.58L44.21,47.0978a26.7656,26.7656,0,0,0,22.6972,12.58H81.8023A26.8662,26.8662,0,0,0,96.7154,55.16l.0079-.0065a26.7447,26.7447,0,0,0,14.8689,4.5238h14.8951A26.8662,26.8662,0,0,0,141.4,55.16l.0079-.0065a26.7447,26.7447,0,0,0,14.8689,4.5238Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.2785,13.5986V.165h2.6074V13.4336c0,4.9834,2.6406,7.7891,7.0635,7.7891,4.2568,0,6.9638-2.5743,6.9638-7.6241V.165h2.6075V13.4c0,6.7334-3.8623,10.2314-9.6377,10.2314C191.173,23.6318,187.2785,20.1338,187.2785,13.5986Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-2",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.6379.165h2.6074V20.8594h13.0039v2.4092H217.6379Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-3",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.8215,2.5752h-7.7891V.165h18.1855v2.41h-7.789V23.2686h-2.6074Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-4",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.1466.165h2.6075V23.2686h-2.6075Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-5",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.4689.165H283.11l8.4161,12.6084L299.9416.165h2.6406V23.2686h-2.6074V4.5547l-8.416,12.3769h-.1329L283.01,4.5879V23.2686h-2.541Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-6",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.6105,0h2.4424l10.5283,23.2686h-2.8047l-2.707-6.1055H317.4953l-2.7393,6.1055h-2.6738Zm6.4365,14.8193L323.799,3.0371l-5.2813,11.7822Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-7",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.6183,48.5332v-.0664c0-6.3369,4.6543-11.9473,11.585-11.9473a12.1736,12.1736,0,0,1,8.6142,3.0694l-1.6835,1.98a9.8269,9.8269,0,0,0-7.03-2.6406c-5.1153,0-8.7783,4.3233-8.7783,9.4727v.0654c0,5.5117,3.5312,9.6045,9.1416,9.6045a10.8728,10.8728,0,0,0,6.667-2.3106V50.0186h-7.03V47.6748h9.539v9.209a14.0007,14.0007,0,0,1-9.2744,3.5312C191.1076,60.415,186.6183,55.1338,186.6183,48.5332Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-8",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.464,36.915h16.7v2.377H221.0715V47.18h12.6074v2.3769H221.0715v8.086h14.2578v2.376H218.464Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-9",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.5236,36.915h2.4424l14.5547,18.5157V36.915h2.542V60.0186h-2.08l-14.918-18.9444V60.0186h-2.541Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-10",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.5187,48.5332v-.0664a11.7835,11.7835,0,1,1,23.5654-.0654v.0654a11.7835,11.7835,0,1,1-23.5654.0664Zm20.8594,0v-.0664c0-5.2471-3.8291-9.5381-9.1094-9.5381s-9.043,4.2246-9.043,9.4727v.0654c0,5.248,3.8282,9.5391,9.1084,9.5391S296.3781,53.7812,296.3781,48.5332Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-11",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.5422,36.915h2.6406l8.416,12.6084,8.416-12.6084h2.6406V60.0186H329.048V41.3047l-8.416,12.3769h-.1328l-8.416-12.3437V60.0186h-2.541Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-12",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.3664,36.915h2.6074V60.0186h-2.6074Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-13",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.6642,48.5332v-.0664A11.6394,11.6394,0,0,1,368.3478,36.52a12.0281,12.0281,0,0,1,9.0108,3.6631l-1.7823,1.9151a10.0409,10.0409,0,0,0-7.2617-3.169c-5.1152,0-8.9433,4.1582-8.9433,9.4727v.0654c0,5.3467,3.8613,9.5391,8.9433,9.5391,3.169,0,5.2481-1.2217,7.46-3.334l1.7158,1.6836a12.03,12.03,0,0,1-9.2412,4.06A11.524,11.524,0,0,1,356.6642,48.5332Z",
    style: {
      fill: "#0a1f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "fullLogo-14",
    "data-name": "fullLogo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.6047,56.6523l1.6171-1.914a11.0047,11.0047,0,0,0,7.9219,3.2676c3.1016,0,5.1485-1.65,5.1485-3.9278v-.0664c0-2.1455-1.1553-3.3662-6.0069-4.39-5.3135-1.1553-7.7558-2.8711-7.7558-6.667V42.89c0-3.6308,3.2011-6.3046,7.5908-6.3046a12.0574,12.0574,0,0,1,8.1191,2.8388l-1.5185,2.0137a10.1436,10.1436,0,0,0-6.667-2.5088c-3.003,0-4.917,1.65-4.917,3.73v.0664c0,2.1777,1.1875,3.3994,6.27,4.4883,5.1484,1.1221,7.5254,3.0039,7.5254,6.5351v.0655c0,3.9609-3.3008,6.5351-7.8887,6.5351A13.5178,13.5178,0,0,1,385.6047,56.6523Z",
    style: {
      fill: "#0a1f8f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltimaSvgLogo);
export default __webpack_public_path__ + "static/media/UltimaSvgLogo.09bc775d2d71d32a8e03dac6ee0b0a1f.svg";
export { ForwardRef as ReactComponent };